import { Input, Component, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { SnFormFieldConfig } from '@lib/form';
import { SnUserFieldsGeneratorService } from '@lib/users';

const VERIFICATION_CODE_REGEXP = /^\d{6}$/;

@Component({
  selector: 'sn-reset-confirm-form',
  templateUrl: './reset-confirm-form.component.html',
  styleUrls: ['./reset-confirm-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetConfirmFormComponent {
  @Input()
  public readonly form = new UntypedFormGroup({});

  @Input()
  public formModel: any = {};

  @Input()
  public phoneConfirmationRequired: boolean;

  public readonly formFields: SnFormFieldConfig[];

  constructor(private readonly _userFieldsGeneratorService: SnUserFieldsGeneratorService) {
    this.formFields = this._getFormFields();
    if (!this.phoneConfirmationRequired) {
      this.formModel['verification-code'] = '000000';
    }
  }

  private _getFormFields(): SnFormFieldConfig[] {
    return [
      this._userFieldsGeneratorService.getPasswordField({
        key: 'newPassword',
        templateOptions: {
          label: 'New password',
          required: true,
          attributes: {
            autocomplete: 'new-password',
          },
        },
      }),
      this._userFieldsGeneratorService.getPasswordField({
        key: 'confirmPassword',
        templateOptions: {
          label: 'Confirm password',
          attributes: {
            autocomplete: 'new-password',
          },
        },
        validators: {
          fieldMatch: {
            expression: (control) => control.value === this.formModel.newPassword,
            message: 'Passwords do not match',
          },
        },
      }),
      this._userFieldsGeneratorService.getVerificationCodeField({
        className: 'verification-code',
        templateOptions: {
          required: true,
          pattern: VERIFICATION_CODE_REGEXP,
          attributes: {
            autocomplete: 'new-password',
          },
        },
        validation: {
          messages: {
            pattern: 'Wrong number of digits',
          },
        },
        hideExpression: () => !this.phoneConfirmationRequired,
      }),
    ];
  }
}
